<template>
    <section class="h-screen bg-black text-white relative">
        <div class="h-full w-full absolute">
            <TransitionFadeBackground>
                <MoleculeSliderCurrentVideo :video="currentSlide" />
            </TransitionFadeBackground>
            <div class="bg-black opacity-30 w-full h-full absolute z-10 top-0 left-0"></div>
        </div>

        <div class="z-20 relative h-full w-full flex justify-center flex-col">
            <TransitionFadeTitle>
                <div :key="`slide-${currentSlideNumber}`"
                     class="px-3 lg:p-12 lg:mb-0 lg:pr-[300px] mb-10 flex flex-col gap-4">
                    <div class="font-vectrex text-uppercase text-4xl lg:text-7xl !leading-tight">
                        {{ currentSlide.title }}
                    </div>

                    <router-link class="flex gap-3 items-center"
                                 :to="{name: 'video.view', params: {id: currentSlide.id, slug: currentSlide.slug}}">
                        <div
                            class="rounded-full flex items-center justify-center h-[45px] w-[45px] border border-white">
                            <span class="material-symbols-outlined text-xl">play_arrow</span>
                        </div>
                        {{ $t('video.play') }}
                    </router-link>
                </div>
            </TransitionFadeTitle>

            <div class="absolute bottom-0 left-0 w-full">
                <div class="mb-10 px-3 lg:px-12 overflow-hidden">
                    <VueSlickCarousel @afterChange="handleCarouselSlideChange" ref="carousel" class="slick-slider-carousel" v-bind="settingsSlider">
                        <MoleculeSliderVideo
                            v-for="(video, index) in slides"
                            :key="index"
                            :video="video"
                            :is-active="currentSlideNumber !== index+1"
                            @click.native="setCurrentSlideNumber(index+1)"
                        />
                    </VueSlickCarousel>
                </div>

                <AtomCarouselLoadingBar
                    :current-slide-number="currentSlideNumber"
                    :duration-css-string="durationCssString"
                    :timer-width-class="timerWidthClass"
                />
            </div>
        </div>
    </section>
</template>

<script>
import TransitionFadeBackground from "../../../transitions/home/TransitionFadeBackground.vue";
import TransitionFadeVideo from "../../../transitions/home/TransitionFadeVideo.vue";
import TransitionFadeTitle from "../../../transitions/home/TransitionFadeTitle.vue";
import carousel from "../../../mixins/carousel";
import AtomCarouselLoadingBar from "../../global/atoms/AtomCarouselLoadingBar.vue";
import secondsToMinutes from "../../../utils/secondsToMinutes";
import TransitionFade from "../../../transitions/TransitionFade.vue";
import VueSlickCarousel from "vue-slick-carousel";
import {mapState} from "vuex";
import MoleculeSliderVideo from "../../video/molecules/MoleculeSliderVideo.vue";
import MoleculeSliderCurrentVideo from "../../video/molecules/MoleculeSliderCurrentVideo.vue";
import _ from "lodash";

export default {
    name: 'OrganismVideosHero',
    components: {
        MoleculeSliderCurrentVideo,
        MoleculeSliderVideo, TransitionFade, VueSlickCarousel, AtomCarouselLoadingBar, TransitionFadeTitle,
        TransitionFadeVideo, TransitionFadeBackground
    },
    mixins: [carousel],
    data() {
        return {
            settingsSlider: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,

                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            infinite: true,
                            centerPadding: "0px",
                            swipeToSlide: true,
                            variableWidth: true,
                            draggable: true,
                        }
                    },
                ]
            }
        }
    },
    computed: {
        ...mapState('video', {
            videos: 'videos'
        }),
        slides() {
            return _.sortBy(this.videos.filter(video => video.header_position), 'header_position');
        }
    },
    methods: {
        secondsToMinutes,
        handleCarouselSlideChange(index) {
            this.setCurrentSlideNumber(index+1)
        }
    },
    watch: {
        currentSlide() {
            this.$refs.carousel.goTo(this.currentSlideNumber-1)
        }
    }
}
</script>

<style scoped lang="scss">
.material-symbols-outlined {
    font-variation-settings: 'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24
}

.overflow-auto {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    /* Hide scrollbar for Chrome, Safari and Opera */

    &::-webkit-scrollbar {
        display: none;
    }
}

.slick-slider-carousel ::v-deep .slick-slide {
    padding: 0;
}
</style>
